class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");

    // This code is for fixing the iOS issue - Search Modal not opening when the keyboard shows up.
    this.searchModal = this.querySelector(".search-modal");
    this.searchInput = this.querySelector(".wizzy-search-input");

    if (!this.searchModal || !this.searchInput) return;

    // Check if the device is iOS
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (this.isIOS) {
      this.setupIOSKeyboardHandling();
    }
  }

  disconnectedCallback() {
    if (this.isIOS && window.visualViewport) {
      window.visualViewport.removeEventListener(
        "resize",
        this.onViewportResize.bind(this)
      );
    }
  }

  setupIOSKeyboardHandling() {
    // Add class to body for iOS specific styling
    document.body.classList.add("ios-device");

    // Handle details opening
    this.detailsContainer.addEventListener(
      "toggle",
      this.onToggleDetails.bind(this)
    );

    // Setup input focus/blur events
    this.searchInput.addEventListener("focus", this.onInputFocus.bind(this));
    this.searchInput.addEventListener("blur", this.onInputBlur.bind(this));

    // Setup visualViewport events if available
    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        "resize",
        this.onViewportResize.bind(this)
      );
    }
  }

  onToggleDetails() {
    if (!this.detailsContainer.open) {
      // Reset modal position when details is closed
      this.searchModal.style.transform = "translateY(0)";
      document.body.classList.remove("ios-keyboard-open");
    }
  }

  onInputFocus() {
    setTimeout(() => {
      const keyboardHeight =
        window.innerHeight -
        (window.visualViewport.height + window.visualViewport.offsetTop);

      if (keyboardHeight > 0) {
        document.body.classList.add("ios-keyboard-open");
        this.searchModal.style.transform = `translateY(-${keyboardHeight}px)`;
      }
    }, 100);
  }

  onInputBlur() {
    // Reset the modal position
    this.searchModal.style.transform = "translateY(0)";
    document.body.classList.remove("ios-keyboard-open");
  }

  onViewportResize() {
    if (document.activeElement === this.searchInput) {
      const keyboardHeight =
        window.innerHeight -
        (window.visualViewport.height + window.visualViewport.offsetTop);
      this.searchModal.style.transform = `translateY(-${keyboardHeight}px)`;
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    const { scrollX, scrollY } = window;
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
    requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);
